import { Request } from "~/services";
import { REACT_APP_API_INTEGRATION_ALM_GEN  } from "~/utils";
import { getTenantIdCookie } from "~/utils/tenants";

type ExportToAzureBody = {
  alm_provider: string // azure | xray (jira)
  csv_data: {
    id: number | string
    summary: string
    description: string[]
  }[]
}

export async function exportToAzure({ alm_provider, csv_data }: ExportToAzureBody) {
  const response = await Request(REACT_APP_API_INTEGRATION_ALM_GEN ?? '').post(
    `/download_csv?tenant_id=${getTenantIdCookie()}`,
    { alm_provider, csv_data },
    { responseType: 'blob' }
  );
  return response;
}